import { useEffect, useRef, useState } from 'react';
import api from '../services/api';

export const usePremiumCoupons = () => {
  const [premiumCoupons, setPremiumCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const couponsRef = useRef([]);

  const loadCoupons = async (showLoading = false) => {
    try {
      if (showLoading) setLoading(true);
      setError(null);
      const data = await api.getDailyPremiumCoupons();
      const coupons = data.coupons || [];
      couponsRef.current = coupons;
      setPremiumCoupons(coupons);
      setRefreshing(data?.status === 'preparing');
      setLastUpdated(data?.lastUpdated || null);
      setError(null);
    } catch (err) {
      couponsRef.current = [];
      setPremiumCoupons([]);
      setLastUpdated(null);
      setRefreshing(false);
      setError(err?.message || 'Premium kuponlar su anda hazirlaniyor.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let active = true;

    const guardedLoad = async (showLoading = false) => {
      if (!active) return;
      await loadCoupons(showLoading);
    };

    guardedLoad(true);

    const intervalId = window.setInterval(() => {
      if (!active) return;
      if (couponsRef.current.length === 0) {
        guardedLoad(false);
      }
    }, 15000);

    return () => {
      active = false;
      window.clearInterval(intervalId);
    };
  }, []);

  return {
    premiumCoupons,
    loading,
    error,
    refreshing,
    lastUpdated,
    refetch: () => loadCoupons(true)
  };
};
